<div
  class="dropzone"
  [class.dropzone--active]="isDragOver"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  <span class="dropzone__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" focusable="false">
      <path fill="currentColor" d="M12 3.1 6.6 8.5l1.4 1.4L11 6.9V16h2V6.9l3 3 1.4-1.4L12 3.1ZM5 17v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2v3H7v-3H5Z" />
    </svg>
  </span>
  <p class="dropzone__title">{{ title }}</p>
  <p class="dropzone__hint">{{ hint }}</p>
  <input
    #fileInput
    type="file"
    class="dropzone__native-input"
    [attr.aria-label]="title"
    [accept]="accept"
    [multiple]="multiple"
    (change)="onNativeChange($event)" />
</div>
